import { Component, EventEmitter, Injector, OnInit, Output, ViewChild } from '@angular/core';
import { HvlFormGroup } from '@hvlng/framework-bff/core';
import { DropdownOption, UiEnumService } from 'ui-shared';
import { LazyLoadEvent, MenuItem } from 'primeng/api';
import { HrBaseListPageNew } from '../../../../common/base-form/hr-base-list-page-new';
import { CodeTextDiscriminatorQueryModel } from '../../model/code-text-discriminator-query-model';
import { CodeTextService } from '../../service/code-text-service';
import { CodeTextDiscriminatorModel } from '../../model/code-text-discriminator-model';
import {
    EducationDiscriminatorValues,
    GeneralDiscriminatorValues,
    PayrollDiscriminatorValues,
    PerformanceDiscriminatorValues,
    PersonnelDiscriminatorValues,
    RecruitmentDiscriminatorValues,
} from '../../model/code-text-discriminator-values';
import { HvlFormConstants } from '@hvlng/framework-core/form';
import { HrModuleType } from '../../../../../lib/common/model/hr-module-type';
import { ActivatedRoute } from '@angular/router';
import { Table } from 'primeng/table';

@Component({
    selector: 'code-text-list',
    templateUrl: './code-text-list.component.html',
})
export class CodeTextListComponent extends HrBaseListPageNew<CodeTextDiscriminatorModel> implements OnInit {
    @ViewChild('dataTable') dataTableComponent: Table;
    @Output() onDiscriminatorValueChangedEvent: EventEmitter<DropdownOption> = new EventEmitter();
    @Output() onSearchCleared = new EventEmitter<void>();

    codeTextQueryModelForm = new HvlFormGroup<CodeTextDiscriminatorQueryModel>(new CodeTextDiscriminatorQueryModel());
    discriminatorValueList: Array<DropdownOption>;
    selectedDiscriminator: string;
    collapsed: boolean = false;
    moreItems: MenuItem[] = [{}];
    changeValue: string;
    selectedLabel: string;
    routeName: HrModuleType;

    constructor(
        private codeTextService: CodeTextService,
        private enumService: UiEnumService,
        private injector: Injector,
        private activatedRoute: ActivatedRoute,
    ) {
        super(injector);
        this.setListTitle();
    }

    ngOnInit() {
        this.activatedRoute.data.subscribe((params) => {
            this.routeName = params.module;
            this.loadDropdownData();
        });
    }

    loadDropdownData() {
        this.discriminatorValueList = this.enumService.createDropdownList(
            this.getDiscriminatorEnumType(),
            this.translateService.instant('hrCommonCodeText.discriminatorValues'),
            true,
        );
        //TODO: discriminator tanımı düzeltildiğinde silinecek
        if (this.routeName != HrModuleType.PERFORMANCE)
            return;

        this.codeTextService.getDiscriminatorDefinitions(HrModuleType.PERFORMANCE)
            .subscribe(res => {
                    const dynamicOptions= res.map(it => {
                        const option = new DropdownOption();
                        option.value = it.code;
                        option.label = it.longText;
                        return option;
                    });
                this.discriminatorValueList = [...this.discriminatorValueList, ...dynamicOptions];
                }
            );
    }

    getDiscriminatorEnumType() {
        switch (this.routeName) {
            case HrModuleType.GENERAL:
                return GeneralDiscriminatorValues;
            case HrModuleType.PAYROLL:
                return PayrollDiscriminatorValues;
            case HrModuleType.PERSONNEL:
                return PersonnelDiscriminatorValues;
            case HrModuleType.PERFORMANCE:
                return PerformanceDiscriminatorValues;
            case HrModuleType.RECRUITMENT:
                return RecruitmentDiscriminatorValues;
            case HrModuleType.EDUCATION:
                return EducationDiscriminatorValues;
            default:
                return GeneralDiscriminatorValues;
        }
    }

    loadCodeTextTableEvent(event: LazyLoadEvent) {
        this.tableEvent = event;
        if (this.changeValue == null) {
            return;
        }
        this.codeTextQueryModelForm = this.preparePageable(this.tableEvent, this.codeTextQueryModelForm);
        if (!this.tableEvent.sortField) {
            this.codeTextQueryModelForm.value.pageable.sort.properties = ['code'];
            this.codeTextQueryModelForm.value.pageable.sort.direction = 'ASC';
        }
        this.serviceCall.callListService(
            this,
            this.codeTextService.queryPage(this.codeTextQueryModelForm.value, this.routeName),
            (response) => {
                this.setTableData(response);
            },
        );
    }

    onDiscriminatorValueChanged(value) {
        this.changeValue = value;
        this.selectedLabel = this.discriminatorValueList.find(it => it.value == value)?.label;
        this.dataTableComponent.sortField = undefined;
    }

    setListTitle() {
        if (this.selectedLabel != null) {
            this.listTitle = this.getFormTitleSync(this.selectedLabel, HvlFormConstants.LIST);
        }
    }

    clear() {
        this.onDiscriminatorValueChanged(null);
        this.codeTextQueryModelForm.reset();
        this.clearTableData();
        this.listTitle = null;
        this.onSearchCleared.emit();
    }

    collapseOrToggle() {
        this.collapsed = !this.collapsed;
    }

    bindActionMenuItems() {
        this.moreItems = [
            {
                label: this.translateSync(this.hrKey.common.pageTitleCardOptions),
                items: [
                    {
                        icon: 'pi pi-info',
                        label: this.translateSync(this.hrKey.hrCommonCodeText.search),
                    },
                ],
            },
        ];
    }

    onDiscriminatorValueSelect() {
        this.codeTextQueryModelForm.value.discriminator = this.changeValue;
        const option = new DropdownOption();
        option.value = this.changeValue;
        option.label = this.selectedLabel;
        this.onDiscriminatorValueChangedEvent.emit(option);
        if (this.changeValue == null) {
            this.clearTableData();
            this.listTitle = null;
            return;
        }
        this.setListTitle();
        this.refreshTable();
    }
}
